import script from "./AvatarChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarChat.vue?vue&type=script&setup=true&lang=js"

import "./AvatarChat.vue?vue&type=style&index=0&id=4482555e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4482555e"]])

export default __exports__